// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__33A9a","row":"Node_row__1-w-f","label":"Node_label__jznKb","footer":"Node_footer__3N60c"};